<ul class="navbar-nav ml-auto">
    <li>
        <div class="dropdown drp-user" *ngIf="privilegeData.notificationPendingFeeCall">
            <i class="fa fa-search-dollar" style="font-size: 20px;padding: 0px 10px;cursor: pointer;" (click)="dailyPaymentReminderList()"><span id="dailyFeesReminderCount" style="vertical-align: super;"></span></i>
        </div>
      </li>
  <li>
    <div class="dropdown drp-user" *ngIf="privilegeData.notificationTodayFeeCall">
        <i class="fa fa-rupee-sign" style="font-size: 20px;padding: 0px 10px;cursor: pointer;" (click)="pendingPaymentReminderList()"><span id="pendingFeesReminderCount" style="vertical-align: super;"></span></i>
    </div>
  </li>
  <li>
    <div class="dropdown drp-user" *ngIf="privilegeData.notificationLeadTransfer">
        <i class="icon feather icon-arrow-down-left" style="font-size: 20px;padding: 0px 10px;cursor: pointer;" (click)="showTransferLeadList()"><span id="transferLeadCount" style="vertical-align: super;"></span></i>
    </div>
  </li>
  <li>
    <div class="dropdown drp-user" *ngIf="privilegeData.notificationPendingFollowupCall">
        <i class="icon feather icon-phone-missed" style="font-size: 20px;padding: 0px 10px;cursor: pointer;" (click)="showPendingCallList()"><span id="pendingCallCount" style="vertical-align: super;"></span></i>
    </div>
  </li>
  <li>
    <div class="dropdown drp-user" *ngIf="privilegeData.notificationTodayFollowupCall">
        <i class="icon feather icon-phone" style="font-size: 20px;padding: 0px 10px;cursor: pointer;" (click)="showTodayPendingCallList()"><span id="todayPendingCallCount" style="vertical-align: super;"></span></i>
    </div>
  </li>
  <li>
    <div class="dropdown drp-user">
        <i class="icon feather icon-log-out" (click)="logOut()" style="font-size: 20px;padding: 0px 10px;cursor: pointer;"></i>
    </div>
  </li>
</ul>
